<div style="width:50%; margin-left: auto; margin-right: auto;">
    <div class="cont-header">
        <img
            style="height: 4rem; background-color: #002244;"
            src="../../../../../assets/WhatNow-logo-version1_rev_2.png"
        />
        <span class="vertical-center">
            <!-- <h1> -->
                Sub-Brand Registration Form
            <!-- </h1> -->
        </span>
    </div>
    <div class="cont-body">
        <form [formGroup]="subAccountInfo">
            <mat-card >
                <mat-card-header>
                  <div mat-card-avatar ><mat-icon>store</mat-icon></div>
                  <mat-card-title>Organization Info</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field>
                        <mat-label>Organization Name </mat-label>
                        <input matInput placeholder="Organization Name" formControlName="orgName" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Organization Email</mat-label>
                        <input matInput placeholder="Organization Email" formControlName="orgEmail" required >
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
    
            <mat-card >
                <mat-card-header>
                  <div mat-card-avatar ><mat-icon>person</mat-icon></div>
                  <mat-card-title>User Info</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput placeholder="First Name" formControlName="firstName" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput placeholder="Last Name" formControlName="lastName" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput placeholder="Email" formControlName="email" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Phone</mat-label>
                        <input matInput placeholder="Phone" formControlName="phone" required >
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
    
            <mat-card >
                <mat-card-header>
                  <div mat-card-avatar ><mat-icon>location_city</mat-icon></div>
                  <mat-card-title>User Address</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field>
                        <mat-label>Street</mat-label>
                        <input matInput placeholder="Street" formControlName="street" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="city" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Region</mat-label>
                        <input matInput placeholder="Region" formControlName="region" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Postal Code</mat-label>
                        <input matInput placeholder="Postal Code" formControlName="pin" required >
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <mat-label>Country</mat-label>
                        <input matInput placeholder="Country" formControlName="country" required >
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </form>
    </div>
</div>
